import React, { useEffect, useState } from 'react';

const PaymentFailed = () => {
  const [countdown, setCountdown] = useState(5);
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    // Trigger entrance animation
    setTimeout(() => setIsVisible(true), 100);

    // Handle resize
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);

    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          // Redirect to dashboard
          window.location.href = '/';
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(timer);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleRetry = () => {
    window.location.href = '/';
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      padding: isMobile ? '1rem' : '2rem',
      position: 'relative'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `radial-gradient(circle at 25% 25%, rgba(224, 79, 96, 0.03) 0%, transparent 50%),
                         radial-gradient(circle at 75% 75%, rgba(224, 79, 96, 0.03) 0%, transparent 50%)`,
        pointerEvents: 'none'
      }} />

      {/* Header Logo */}
      <div style={{
        position: 'absolute',
        top: isMobile ? '1rem' : '2rem',
        left: isMobile ? '1rem' : '2rem',
        display: 'flex',
        alignItems: 'center',
        zIndex: 10
      }}>
        <img 
          src="/assets/cheese2.png" 
          width={isMobile ? 28 : 32} 
          alt="Ricotta" 
          style={{ marginRight: '0.5rem' }} 
        />
        <span style={{ 
          color: '#E04F60', 
          fontWeight: '700', 
          fontSize: isMobile ? '1.1rem' : '1.2rem',
          letterSpacing: '-0.025em'
        }}>
          Ricotta
        </span>
      </div>

      {/* Main Content */}
      <div 
        className={`payment-failed-container ${isVisible ? 'animate-in' : ''}`}
        style={{
          maxWidth: isMobile ? '95%' : '650px',
          width: '100%',
          background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
          borderRadius: '24px',
          padding: isMobile ? '2.5rem 1.5rem' : '4rem 3rem',
          textAlign: 'center',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.08), 0 8px 25px rgba(0, 0, 0, 0.04)',
          border: '1px solid rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(10px)',
          position: 'relative',
          overflow: 'hidden',
          transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.95)',
          opacity: isVisible ? 1 : 0,
          transition: 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      >
        {/* Subtle background glow */}
        <div style={{
          position: 'absolute',
          top: '-50%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '120%',
          height: '200%',
          background: 'radial-gradient(ellipse at center, rgba(224, 79, 96, 0.03) 0%, transparent 70%)',
          pointerEvents: 'none',
          zIndex: 0
        }} />

        {/* Content */}
        <div style={{ position: 'relative', zIndex: 1 }}>
          {/* Error Icon */}
          <div style={{ 
            marginBottom: isMobile ? '1.5rem' : '2rem',
            transform: isVisible ? 'scale(1)' : 'scale(0.8)',
            transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.2s'
          }}>
            <div style={{
              width: isMobile ? '80px' : '100px',
              height: isMobile ? '80px' : '100px',
              background: 'linear-gradient(135deg, #E04F60 0%, #c94456 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
              boxShadow: '0 10px 30px rgba(224, 79, 96, 0.3)',
              animation: isVisible ? 'pulse-error 2s infinite' : 'none'
            }}>
              <i className="fas fa-times" style={{
                fontSize: isMobile ? '2.5rem' : '3rem',
                color: 'white'
              }}></i>
            </div>
          </div>

          {/* Title */}
          <h1 style={{
            color: '#2C3E50',
            fontSize: isMobile ? '2rem' : '2.5rem',
            fontWeight: '700',
            marginBottom: '1rem',
            letterSpacing: '-0.025em',
            lineHeight: '1.2'
          }}>
            Payment Failed 😔
          </h1>

          {/* Subtitle */}
          <p style={{
            color: '#6c757d',
            fontSize: isMobile ? '1rem' : '1.1rem',
            lineHeight: '1.6',
            marginBottom: isMobile ? '1.5rem' : '2rem',
            maxWidth: '450px',
            margin: `0 auto ${isMobile ? '1.5rem' : '2rem'} auto`
          }}>
            We encountered an issue processing your payment. Don't worry, <strong style={{ color: '#E04F60' }}>no charges were made</strong> to your account.
          </p>

          {/* Common Issues Grid */}
          {/* <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
            gap: isMobile ? '1rem' : '1.5rem',
            margin: isMobile ? '1.5rem 0' : '2rem 0',
            padding: isMobile ? '1.5rem' : '2rem',
            background: 'rgba(224, 79, 96, 0.04)',
            borderRadius: '16px',
            border: '1px solid rgba(224, 79, 96, 0.08)',
            textAlign: 'left'
          }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
              <div style={{
                width: '32px',
                height: '32px',
                background: 'linear-gradient(135deg, #E04F60 0%, #c94456 100%)',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '2px'
              }}>
                <i className="fas fa-credit-card" style={{ fontSize: '0.875rem', color: 'white' }}></i>
              </div>
              <div>
                <h6 style={{ color: '#2C3E50', marginBottom: '0.25rem', fontWeight: '600', fontSize: '0.9rem' }}>Card Declined</h6>
                <small style={{ color: '#6c757d', lineHeight: '1.4' }}>Check with your bank or try a different payment method</small>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
              <div style={{
                width: '32px',
                height: '32px',
                background: 'linear-gradient(135deg, #E04F60 0%, #c94456 100%)',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '2px'
              }}>
                <i className="fas fa-wallet" style={{ fontSize: '0.875rem', color: 'white' }}></i>
              </div>
              <div>
                <h6 style={{ color: '#2C3E50', marginBottom: '0.25rem', fontWeight: '600', fontSize: '0.9rem' }}>Insufficient Funds</h6>
                <small style={{ color: '#6c757d', lineHeight: '1.4' }}>Ensure your account has sufficient balance</small>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
              <div style={{
                width: '32px',
                height: '32px',
                background: 'linear-gradient(135deg, #E04F60 0%, #c94456 100%)',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '2px'
              }}>
                <i className="fas fa-calendar-times" style={{ fontSize: '0.875rem', color: 'white' }}></i>
              </div>
              <div>
                <h6 style={{ color: '#2C3E50', marginBottom: '0.25rem', fontWeight: '600', fontSize: '0.9rem' }}>Expired Card</h6>
                <small style={{ color: '#6c757d', lineHeight: '1.4' }}>Update your card information and try again</small>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
              <div style={{
                width: '32px',
                height: '32px',
                background: 'linear-gradient(135deg, #E04F60 0%, #c94456 100%)',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '2px'
              }}>
                <i className="fas fa-wifi" style={{ fontSize: '0.875rem', color: 'white' }}></i>
              </div>
              <div>
                <h6 style={{ color: '#2C3E50', marginBottom: '0.25rem', fontWeight: '600', fontSize: '0.9rem' }}>Network Issues</h6>
                <small style={{ color: '#6c757d', lineHeight: '1.4' }}>Check your internet connection and retry</small>
              </div>
            </div>
          </div> */}

          {/* Countdown Section */}
          <div style={{
            background: 'linear-gradient(135deg, #6c757d 0%, #495057 100%)',
            color: 'white',
            padding: isMobile ? '1.25rem' : '1.5rem',
            borderRadius: '16px',
            marginBottom: isMobile ? '1.5rem' : '2rem',
            boxShadow: '0 8px 25px rgba(108, 117, 125, 0.25)'
          }}>
            <h5 style={{ 
              marginBottom: '0.75rem', 
              fontWeight: '600',
              fontSize: isMobile ? '1.1rem' : '1.25rem'
            }}>
              <i className="fas fa-home me-2"></i>
              Returning to dashboard...
            </h5>
            <div style={{
              fontSize: isMobile ? '1.75rem' : '2rem',
              fontWeight: '700',
              marginBottom: '0.5rem',
              fontFamily: 'monospace'
            }}>
              {countdown}
            </div>
            <small style={{ opacity: 0.9, fontSize: '0.9rem' }}>seconds remaining</small>
          </div>

          {/* Action Buttons */}
          <div style={{
            display: 'flex',
            gap: isMobile ? '0.75rem' : '1rem',
            justifyContent: 'center',
            flexWrap: 'wrap',
            marginBottom: isMobile ? '1.5rem' : '2rem'
          }}>
            <button 
              onClick={handleRetry}
              style={{
                background: 'linear-gradient(135deg, #E04F60 0%, #c94456 100%)',
                border: 'none',
                color: 'white',
                fontWeight: '600',
                padding: isMobile ? '12px 20px' : '14px 28px',
                borderRadius: '50px',
                fontSize: '0.95rem',
                cursor: 'pointer',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                boxShadow: '0 6px 20px rgba(224, 79, 96, 0.3)',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                whiteSpace: 'nowrap'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 10px 30px rgba(224, 79, 96, 0.4)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 6px 20px rgba(224, 79, 96, 0.3)';
              }}
            >
              <i className="fas fa-redo"></i>
              Try Again
            </button>

            {/* <button 
              onClick={() => window.location.href = 'https://teams.microsoft.com/'}
              style={{
                background: 'transparent',
                border: '2px solid #6c757d',
                color: '#6c757d',
                fontWeight: '600',
                padding: isMobile ? '10px 18px' : '12px 26px',
                borderRadius: '50px',
                fontSize: '0.95rem',
                cursor: 'pointer',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                whiteSpace: 'nowrap'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#6c757d';
                e.target.style.color = 'white';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#6c757d';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              <i className="fab fa-microsoft"></i>
              Return to Teams
            </button> */}
          </div>

          {/* Support Section */}
          <div style={{
            borderTop: '1px solid rgba(0,0,0,0.08)',
            paddingTop: isMobile ? '1.25rem' : '1.5rem',
            marginBottom: isMobile ? '1rem' : '1.5rem'
          }}>
            <h6 style={{ color: '#2C3E50', marginBottom: '0.75rem', fontWeight: '600' }}>Need Assistance?</h6>
            <p style={{ color: '#6c757d', fontSize: '0.9rem', marginBottom: '1rem' }}>
              If you continue to experience issues, our support team is here to help:
            </p>
            <div style={{
              display: 'flex',
              gap: isMobile ? '0.5rem' : '0.75rem',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
              <a 
                href="mailto:cheese@ricotta.team?subject=Payment Issue - Teams Billing"
                style={{
                  background: 'transparent',
                  border: '1px solid #E04F60',
                  color: '#E04F60',
                  fontWeight: '500',
                  padding: isMobile ? '8px 16px' : '10px 20px',
                  borderRadius: '25px',
                  fontSize: '0.85rem',
                  textDecoration: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#E04F60';
                  e.target.style.color = 'white';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#E04F60';
                }}
              >
                <i className="fas fa-envelope"></i>
                Email Support
              </a>
              {/* <a 
                href="https://ricotta.team/support"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: 'transparent',
                  border: '1px solid #6c757d',
                  color: '#6c757d',
                  fontWeight: '500',
                  padding: isMobile ? '8px 16px' : '10px 20px',
                  borderRadius: '25px',
                  fontSize: '0.85rem',
                  textDecoration: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#6c757d';
                  e.target.style.color = 'white';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#6c757d';
                }}
              >
                <i className="fas fa-question-circle"></i>
                Help Center
              </a> */}
            </div>
          </div>

          {/* Reassurance Note */}
          <div style={{
            background: 'rgba(40, 167, 69, 0.1)',
            border: '1px solid rgba(40, 167, 69, 0.2)',
            borderRadius: '12px',
            padding: isMobile ? '1rem' : '1.25rem',
            color: '#155724'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
              <i className="fas fa-shield-alt" style={{ color: '#28a745' }}></i>
              <strong style={{ fontSize: '0.9rem' }}>No charges were made to your account.</strong>
            </div>
            <small style={{ display: 'block', marginTop: '0.5rem', opacity: 0.8 }}>
              You can safely retry the payment process.
            </small>
          </div>
        </div>
      </div>

      {/* Add animations */}
      <style jsx>{`
        @keyframes pulse-error {
          0%, 100% {
            box-shadow: 0 10px 30px rgba(224, 79, 96, 0.3);
          }
          50% {
            box-shadow: 0 10px 30px rgba(224, 79, 96, 0.5);
          }
        }
        
        .animate-in {
          animation: slideInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `}</style>
    </div>
  );
};

export default PaymentFailed;